"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryButtonItem = void 0;
var _constants = require("../../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CategoryButtonItem = (param)=>{
    let { categoryId = '', icon, name } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        to: _constants.SiteMap.Category.to(categoryId),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.IconWrapper, {
                className: "icon ".concat(icon)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Text, {
                children: name
            })
        ]
    });
};
exports.CategoryButtonItem = CategoryButtonItem;
